import { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import FormRHF from "../../Components/Form/Form.jsx";
import FormControl from "../../Components/Form/FormControl.jsx";
import FormSelect from "../../Components/Form/FormSelect.jsx";
import FormCheck from "../../Components/Form/FormCheck.jsx";
import { apiGetProprietesFree, apiSoumissionFormulaireDemande } from '../../Datas/datasAutre.js'
import LoadingSpinner from "../../Components/LoadingSpinner.js";
import { appelRecupInfoGet, isValidSIRET } from '../../fonctionsDiv.js';


import '../../config.js';

const Etape5bQuiformeFail = ({ formData, setFormData, onPrevious, onNext }) => {
    const navigate = useNavigate();

    // pour react-select
    const [dataVillePourSelect, SetDataVillePourSelect] = useState(); // ici la cible ne contiendra pas les données brutes de l'api mais un tab d'objet ,ex : 0: Object { value: xx, label: "xxx } 
    const [tabObjVillePreselectionnee, SetTabObjVillePreselectionnee] = useState([]); // pour que le reactselect affiche ce qui a déjà été selectionné


    const [dataLoaded, setDataLoaded] = useState(true);
    const [spinnerLoad, setSpinnerLoad] = useState(false);
    const [infosProprietes, SetInfosProprietes] = useState(undefined); // contient les infos sur les champ (taille max, caractre obligatoire, éditable...)
    const [messageProbleme, setMessageProbleme] = useState();
    const [aumoinsUneModif, setAumoinsUneModif] = useState(false); // pour avertir l'utilisateur en cas de sortie sans  enregistrement

    const [dataApi, setdataApi] = useState();
    

     //pour effectuer des actions en fonction de la saisie de l'utilisateur
    async function gestionEvenements(value, name){
      if(global.config.modeDebugApp == 1) console.log (`modif de ${name} : ${value[name]}`);
       console.log ("name : ", name);
       console.log ("value[name] : ", value[name]);
      setAumoinsUneModif(true);

      if(name == "Siret" && value[name].length == 14) {
        var leSiret = value[name];        

        if(!isValidSIRET(leSiret)) {  //.length != 14
          alert("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");  
          return false;
        }
        return false;
      }
      

      // ATTENTION primordial, utilisé ainsi ca ne fonctionne pas :
      //setFormData({ ...formData, name: e.target.value }); 
      //ou meme setFormData({ ...formData, [name]: value[name] });
      //si plusieurs champs sont modifiés très rapidement, formData n’est pas forcément à jour à chaque appel, car mise à jour du state asynchrone
      //Solution : Utilisation de "la version fonctionnelle de setFormData" pour toujours partir de la dernière valeur à jour
      // cela garantit que chaque modification part bien du dernier état connu, même si plusieurs updates sont en attente. C’est la méthode recommandée par React pour ce genre de cas.
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value[name]
      }));
    }

    
    const onSubmit = async (values) => {
      var leSiret = values["Siret"];

      if(!isValidSIRET(leSiret)) {  //.length != 14
        alert("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");
        var ob = document.getElementById("Siret");
        ob.focus();
        return false;
      }
      if(values["Uai"].length > 0 && values["Uai"].length != 8) { 
        alert("Le code UAI doit contenir exactement 8 caractères alphanumérique.");
        var ob = document.getElementById("Uai");
        ob.focus();
        return false;
      }
      if(values["NumDe"].length > 0 && values["NumDe"].length !=11) { 
        alert("Le numéro de déclaration d'activité exactement 11 chiffres.");
        var ob = document.getElementById("NumDe");
        ob.focus();
        return false;
      }

      setMessageProbleme();
      /*setDataLoaded(false);
      for(let i in values) if(values[i] === "") values[i] = null; // sinon génère une erreur : on met à null tout les champs vide (ract-hook-form semble le faire pour nous dans le cas ou on lui passe les valeurs par défaut en entré)
    
      if(values["ResponsableMail"] != values["ResponsableMailConfirm"]) {
        alert("L\'e-mail de confirmation du responsable ne correspond pas à l'e-mail saisi, veuillez vérifier votre saisie.");
        var ob = document.getElementById("ResponsableMail");
        ob.focus();
        return false;
      }

      //values["Codepostal"]  = "26260"
      //values["Commune"] = "Valence";
      //values["VilleId"] = "12345"; si on devait enregistrer l'id.. pas utile à priori

      if(global.config.modeDebugApp == 1) console.log("Values:::", values);
      if(global.config.modeDebugApp == 1) console.log("Values:::", JSON.stringify(values));

      var dataR = await apiSoumissionFormulaireDemande("", values, "envoi-formulaire/inscription");
      if(global.config.modeDebugApp == 1) console.log('retour apiSoumissionFormulaireDemande : ', dataR);

      switch (dataR.statusCode) {
          case 200: 
                alert("Votre demande a bien été transmise, nous vérifions l'ensemble des éléments communiqués et revenons vers vous dans les plus brefs délais.");
              navigate('/'); // Redirect to homepage
              break;
          case 401:
              setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
              break;
          default:
              setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
      }
      setDataLoaded(true);
      */
      onNext();
    };

    
    const onError = (error) => {
      console.log("ERROR:::", error);
    };
    

    async function recupererProprietesFree() {
        const dataR = await apiGetProprietesFree();
        if(global.config.modeDebugApp == 1) console.log('retour apiGetProprietesFree : ', dataR);
        switch (dataR.statusCode) {
          case 200:
            if(!dataR.dataApi || dataR.dataApi["FormulaireInscription|ResponsableMail"] == undefined) {
              if(global.config.modeDebugApp == 1) console.log("pb dataR.dataApi : ", dataR.dataApi)
              setMessageProbleme(global.config.msgPrTechnique.msgDefaut);
              return;
            }
            // on duplique l'objet  ResponsableMail pour pouvoir demander une confirmation
            var objPourConfirmation =  JSON.parse(JSON.stringify(dataR.dataApi["FormulaireInscription|ResponsableMail"]));
            objPourConfirmation.lib_form = objPourConfirmation.lib_form + " (confirmation)"; // on clone (duplique) l'objet pour que  out fonctionne bien);
            objPourConfirmation.placeholder = objPourConfirmation.placeholder + " (confirmation)";
            dataR.dataApi["FormulaireInscription|ResponsableMailConfirm"] = objPourConfirmation
            
            SetInfosProprietes(dataR.dataApi);
             break;
          default:
            setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
        }
    }

    function handleChangeVilleSelect (selectedOptions)  {
      if(global.config.modeDebugApp == 1) console.log("ville selectionnée : ", selectedOptions)
      setFormData({ ...formData, VilleId: selectedOptions.value, Commune: selectedOptions.label }); // on renseigne le champ de la ville avec l'id de la ville sélectionnée

      var preselectionnes = [];
      let ligne = {'value': selectedOptions.value, 'label':  selectedOptions.label};
      preselectionnes.push(ligne);
      SetTabObjVillePreselectionnee(preselectionnes);
    }

    async function chargementsConsecutifs() {
      setDataLoaded(false);
      await recupererProprietesFree();
      var pb = false;
      //var ret = await appelRecupInfoGet("", "LEGALSTATUS", setMessageProbleme); 
      //if(ret != null) SetDataLEGALSTATUS(ret); else pb = true;
      if(pb == true ) setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut

      // pour select ville début
      var ret = await appelRecupInfoGet("", "villes", setMessageProbleme);
      if(ret == null) pb = true;
      
      if(pb == false ) {
        var donneesPourSelect = [];
        ret.forEach((el) => {
            //console.log("el.id : ", el.id, 'lib : , ', el.lib);
            let ligne = {'value': el.id, 'label':  el.lib};
            donneesPourSelect.push(ligne);                                     
        });
        SetDataVillePourSelect(donneesPourSelect); // attention ici la cible ne contiendra pas les données brutes de l'api mais un tab d'objet
      }
      // pour select ville fin

      setFormData({ ...formData, QuiformeEstlaSource: false });
      setDataLoaded(true);
    }

    useEffect(() => {  
        setMessageProbleme(null);
        chargementsConsecutifs();
    }, []);

    const InputWithDiv = (props) => {
      return (<div className="alignement-horizontal-champs-form">
        <FormControl {...props} noCount="1" />
      </div>)
    };
    const FormCheckWithDiv = (props) => {
      return (<div className="alignement-horizontal-champs-form">
        <FormCheck {...props} />
      </div>)
    };



    // Pour test, on renseigne les champs obligatoires
    function renseigneToutPourTest() {
      const testData = {
        ...dataApi,
        Siret: "80486581400029",
        Sigle: "test Sigle",
        RaisonSociale: "nom companie",
        Uai: "12345678",
        NumDe: "12345678912",
        DateDerniereDeclaration: "01/01/2021",
        Uai: "12345678",
        Adresse1: "3 rue de la République",
        Adresse2: "Bâtiment A",
        OrgTelPortable: "04 55 87 84 77",
        OrgTelFixe: "04 55 87 84 78",
        Email: "email-generique@gmail.com",
        SiteWeb: "https://urloups.com",

        /*ResponsableMail: "email-resp@gmail.com",
        ResponsableMailConfirm: "email-resp@gmail.com",
        ResponsablePrenom: "Prénom responsable",
        ResponsableNom: "Nom responsable",
        ResponsableTelPortable: "04 55 87 84 87",
        ResponsableTelFixe: "04 55 87 84 88",*/
      };
      setdataApi(testData);

      /*setFormData({      ...formData,
        RaisonSociale: "responsable nom",
      });*/
    }

  return (
    <div>
        {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape5bQuiformeFail</div>}
        <LoadingSpinner dataLoaded={dataLoaded}/>
        <LoadingSpinner dataLoaded={!spinnerLoad}  className="spinner-container3"/>
        <MessageErreurApi message={messageProbleme} />
        <h3>Déclaration d 'une antenne (qui doit se trouver en PACA) : </h3>
        <h4>QuiForme n'a retourné aucune information concernant le siret {formData.Siret}.<br />
        Vous pouvez toutefois renseigner le formulaire ci-dessous et le Carif vérifiera si ce siret peut être pris en compte.</h4>

        {dataLoaded && infosProprietes && messageProbleme == null &&
        <>
          <ButtonDeBase typeSubmit={true} onClick={renseigneToutPourTest} lib="test : tout renseigner" className2="myside2" className=""/><br />
        
            <FormRHF onSubmit={onSubmit} onError={onError} dataApi={dataApi}  gestionEvenements={gestionEvenements} >
             <div className="titre-inscription">Identité</div>

              <InputWithDiv id="Siret" infosProp={infosProprietes["FormulaireInscription|Siret"]} nolib="1" value={formData.Siret} />
              <FormControl id="RaisonSociale" infosProp={infosProprietes["FormulaireInscription|RaisonSociale"]} nolib="1" value={formData.RaisonSociale}/>
              <InputWithDiv id="Sigle" infosProp={infosProprietes["FormulaireInscription|Sigle"]} nolib="1" value={formData.Sigle} />
              <InputWithDiv id="NumDe" infosProp={infosProprietes["FormulaireInscription|NumDe"]} nolib="1" value={formData.NumDe}  />
              <InputWithDiv id="DateDerniereDeclaration" infosProp={infosProprietes["FormulaireInscription|DateDerniereDeclaration"]} nolib="1" classSpecifique="input-date-inline" value={formData.DateDerniereDeclaration} />
              <br />
              <InputWithDiv id="Uai" infosProp={infosProprietes["FormulaireInscription|Uai"]} nolib="1" value={formData.Uai} />

              {/*<FormSelect id="x_STATUT" infosProp={infosProprietes["FormulaireInscription|x_STATUT"]} options={dataLEGALSTATUS} nolib="1" />*/}

              
              <br />
              
              <div className="titre-inscription-separation">Coordonnées de l'organisme</div>

              <FormControl id="Adresse1" infosProp={infosProprietes["FormulaireInscription|Adresse1"]} nolib="1" value={formData.Adresse1} />
              <FormControl id="Adresse2" infosProp={infosProprietes["FormulaireInscription|Adresse2"]} nolib="1" value={formData.Adresse2} />
              {dataVillePourSelect && dataVillePourSelect.length > 0 &&        
                <Select
                  placeholder="Ville 🏛️ : vous pouvez commencer à saisir les 1ères lettres ou utiliser la liste déroulante 👉" 
                  className="react-select-container2"
                  onChange={handleChangeVilleSelect}
                  closeMenuOnSelect={true}   
                  defaultValue={tabObjVillePreselectionnee }
                  options={dataVillePourSelect} />
              }
              <br />
              <InputWithDiv id="OrgTelPortable" infosProp={infosProprietes["FormulaireInscription|OrgTelPortable"]} nolib="1" value={formData.OrgTelPortable} />
              <InputWithDiv id="OrgTelFixe" infosProp={infosProprietes["FormulaireInscription|OrgTelFixe"]} nolib="1" value={formData.OrgTelFixe} />
              <br />
              <InputWithDiv id="Email" infosProp={infosProprietes["FormulaireInscription|Email"]} nolib="1" value={formData.Email} />
              <FormControl id="SiteWeb" infosProp={infosProprietes["FormulaireInscription|SiteWeb"]} nolib="1" value={formData.SiteWeb} />
              <br />

              {/* fonctionnel mais on a une étape pour cela maintenant
              <div className="titre-inscription-separation">Responsable de l'organisme</div>
              <MessageInfoBox nomClasse="message-info-important" 
                            message="L'Email ci-dessous sera utilisé pour envoyer les identifiants de connexion de votre organisme et les demandes de renouvellement de mot de passe." />< br />

              <InputWithDiv id="ResponsableMail" infosProp={infosProprietes["FormulaireInscription|ResponsableMail"]} nolib="1" />
              <InputWithDiv id="ResponsableMailConfirm" infosProp={infosProprietes["FormulaireInscription|ResponsableMailConfirm"]} nolib="1" /><br />

              <InputWithDiv id="ResponsablePrenom" infosProp={infosProprietes["FormulaireInscription|ResponsablePrenom"]} nolib="1" />
              <InputWithDiv id="ResponsableNom" infosProp={infosProprietes["FormulaireInscription|ResponsableNom"]} nolib="1" /><br />

              <InputWithDiv id="ResponsableTelPortable" infosProp={infosProprietes["FormulaireInscription|ResponsableTelPortable"]} nolib="1" />
              <InputWithDiv id="ResponsableTelFixe" infosProp={infosProprietes["FormulaireInscription|ResponsableTelFixe"]} nolib="1" />
              <br />
              */}

              <div><span className="text-obligatoire">Les champs signalés d'un astérisque rouge * sont obligatoires.</span></div>
              <div className="partie-bouton-droite">
                <ButtonDeBase typeSubmit={false} onClick={onPrevious} lib="Étape précédente" className2="myside2" className="" />
                &nbsp;&nbsp;&nbsp;                
                <ButtonDeBase typeSubmit={true} lib="Étape suivante" disabled={aumoinsUneModif == true ? false : true} />
              </div>
          </FormRHF>
        </>
      }
    </div>
  );
};

export default Etape5bQuiformeFail;
